import "bootstrap/dist/css/bootstrap.min.css";
import "./TeamSection.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import team1 from "../images/dr1.webp";
import team2 from "../images/dr22.webp";
import team3 from "../images/dr33.webp";
import team4 from "../images/dr44.webp";

import leaf1 from "../images/leaf.webp";
import leaf2 from "../images/leaf.webp";
import leaf3 from "../images/leaf.webp";

const teamData = [
  { img: team1, name: "Dr. Shilpa" },
  { img: team2, name: "Dr. Lakshmi" },
  { img: team3, name: "Dr. Athira" },
  { img: team4, name: "Dr. Athulya" },
];

export default function TeamSection() {
  return (
    <section className="container-fluid team-section " style={{backgroundColor:'#f7f0d3'}}>
      <div className="container pt-5">

        {/* Header */}
        <div className="text-center">
        
          <h2 className="team-title para-font">Meet the Healing Hands of Ayur Moksha </h2>
        </div>

        {/* Slider */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
            {/* <img src={leaf1} className="team-leaf-overlay" alt="" /> */}
          {teamData.map((item, index) => (
            
            <SwiperSlide key={index}>
              <div className="team-card text-center">

                {/* Leaf Decorations */}
                <img src={leaf1} className="team-leaf-overlay" alt="" />
                <img src={leaf2} className="team-leaf-overlay" alt="" />
                <img src={leaf3} className="team-leaf-overlay" alt="" />

                {/* Circular Image */}
                <div className="team-img-circle">
                  <img src={item.img} alt={item.name} />
                </div>

                <h5 className="team-name para-font">{item.name}</h5>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}
